export default __webpack_public_path__ + "static/media/iResponsiveVerticalFullSize.7ec6fb86.png";